module.exports = __webpack_public_path__ + "static/media/acceptall.109bdf12.png";